import React, { useEffect, useState } from 'react';
import {
    DataClassificationsOptions,
    DatasetStatistics,
    StatusProps,
} from 'types/Dataset';
import CardIcon from 'components/card/CardIcon';
import EmptyFolderIcon from 'assets/icons/EmptyFolderIcon';
import TableIcon from 'assets/icons/TableIcon';
import { NStatusTag } from '@innersource-nn/novoui-react';
import {
    ClassificationProps,
    getClassificationProps,
} from './DatasetClassification';

interface DatasetCardBodyProps {
    statistics: DatasetStatistics;
    confidentiality: string;
    status?: StatusProps;
}

const DatasetCardBody: React.FC<DatasetCardBodyProps> = ({
    statistics,
    confidentiality,
    status,
}) => {
    const [clasificationProps, setClassificationProps] =
        useState<ClassificationProps>({
            icon: 'success',
            state: 'info',
            label: DataClassificationsOptions.InternalUse,
        });

    useEffect(() => {
        const props: ClassificationProps =
            getClassificationProps(confidentiality);
        setClassificationProps(props);
    }, [confidentiality]);
    const cardIcons = [
        {
            logo: <EmptyFolderIcon className="fill-true-blue" />,
            amount: statistics.locations,
        },
        {
            logo: <TableIcon className="fill-true-blue" />,
            amount: statistics.tables,
        },
    ];

    return (
        <div className="flex justify-between items-center">
            <div className="flex gap-8">
                {cardIcons?.map((extra, index) => (
                    <div
                        className="flex items-center gap-8 p-4"
                        key={`${index}-logo-div`}
                    >
                        {extra.logo}
                        {extra.amount}
                    </div>
                ))}
            </div>
            <div className="flex gap-8 items-center justify-between">
                {(clasificationProps.label ===
                    DataClassificationsOptions.Confidential ||
                    clasificationProps.label ===
                        DataClassificationsOptions.StrictlyConfidential) && (
                    <NStatusTag
                        variant="rounded"
                        label={clasificationProps.label}
                        state={clasificationProps.state}
                    />
                )}
                {status && <CardIcon {...status} />}
            </div>
        </div>
    );
};

export default DatasetCardBody;
